import { APP } from "../shared/constants/constants";

export class LanguageSettings {
  /** The site’s default or current language/locale (e.g. "en-CA") */
  appLocale: string = APP.LANGUAGES[0].value;
  /** The logged‑in user’s preferred language/locale (e.g. "fr-CA") */
  userLocale?: string;
}